import { User } from 'models/user/user';

import { UserRoles } from "models/enums";
export class AccessUtility {
    static isAllowed = (allowedRolles: UserRoles[], loggedInUser?: User) => {
        if ((allowedRolles ?? []).length == 0) {
            return true;
        }
        const _rl = (loggedInUser?.activeRole?.name ?? "") as UserRoles;
        if (_rl == UserRoles.SYSTEM_SUPER_ADMIN) {
            return true;
        } else {
            const _access = loggedInUser != null ? (allowedRolles ?? []).indexOf(_rl) >= 0 : ((allowedRolles ?? []).length <= 0)
            return _access;
        }
    }
}